@for (preset of presets(); track $index) {
  <rp-button size="s" fullWidth (click)="onPresetSelected(preset.value)">
    {{ preset.label | translate }}
  </rp-button>
}
